// reducer that only manages comments
import { COMMENTS } from '../shared/comments';
import * as ActionTypes from './ActionTypes';

export const Comments = (state = COMMENTS, action) => {
    switch (action.type) {
      case ActionTypes.ADD_COMMENT:
        var comment = action.payload;
        comment.id = state.length;
        comment.date = new Date().toISOString();
        console.log("Comment: ", comment);
        return state.concat(comment);

        default:
          return state;
      }
};



// // receive the action and act on it
// export const Comments = (state = {
//   errMess: null,
//   comments: []
// }, action) => {
//   switch(action.type) {
//     case ActionTypes.ADD_COMMENT:
//       var comment = action.payload;
//       return {...state, comments: state.comments.concat(comment)};  // pushes new comment and returns
    
//     case ActionTypes.ADD_COMMENTS:
//       return {...state, 
//         isLoading: false,
//         errMess: null,
//         comments: action.payload};
    
//     case ActionTypes.COMMENTS_FAILED:
//       return {...state, 
//         isLoading: false,
//         errMess: action.payload,
//         comments: []};
        
//     default:
//       return state;
//   }
// }